import React, { FC } from 'react';
import styled from 'styled-components';
import { User } from 'api/models';
import { Avatar } from 'components/atoms/avatar';
import { NameCell as BaseNameCell } from 'components/organisms/timesheets/common/cells/name-cell';
import { fullName } from 'utils/full-name';

const StyledNameCell = styled(BaseNameCell)`
  display: flex;
  padding: 0;
`;

export const NameCell: FC<Pick<User, 'firstName' | 'lastName' | 'photoUrl'>> =
  ({ firstName, lastName, photoUrl }) => {
    const name = fullName({ lastName, firstName });

    return (
      <StyledNameCell
        logo={<Avatar name={name} src={photoUrl} size={18} />}
        primaryText={name}
      />
    );
  };
